const formattedFilmStripData = (videoPlacementPosition, productImagesAndVideos) => {
    const filmStripData = productImagesAndVideos;
    const videoObjects = filmStripData?.filter((obj) => obj?.isVideo === true);
    if (videoObjects?.length === 0) return filmStripData;
    // Remove the last two objects with video: true
    const arrayWithoutVideos = filmStripData?.filter((obj) => {
        return (
            !videoObjects.includes(obj) ||
            videoObjects.indexOf(obj) !== videoObjects.lastIndexOf(obj)
        );
    });
    // Insert the video objects at the configured video placement positions
    arrayWithoutVideos.splice(videoPlacementPosition - 1, 0, ...videoObjects);
    return arrayWithoutVideos;
};

export default formattedFilmStripData;
